export default __webpack_public_path__ + "static/media/arrow-right-white.c311704c.svg";